<template>
    <!-- <div id="page_style" class="flex flex-col items-center w-full h-full bg-transparent overflow-hidden" autocomplete="off"> -->
    <div class="flex flex-col items-center w-full h-full bg-tethys-1 overflow-hidden" autocomplete="off">

        <!-- <div id="filters" class="w-5/6 2xl:w-4/6 h-40 md:h-24 2xl:h-16 3xl:h-20 bg-tethys-1"> -->
        <div class="w-[85vw] sm:w-[75vw] 2xl:w-[67vw] bg-tethys-1">
            <FacetsComponent :facets="facets" :sortByAttribute="sortByAttribute" :sortByOrder="sortByOrder" :hasRectangle="!!store.selectionBox"
                :hasSearchTerm="hasSearchTerm" @filter="onFilter" @clearFacet="onClearFacetCategory"
                @changeOrdering="onChangeOrdering">
            </FacetsComponent>
        </div>

        <!-- MOBILE DEVICES ONLY: Results area on top of the results ==================================================  -->
        <!-- <div class="sm:hidden w-[85vw]"> -->

            <!-- MOBILE DEVICES ONLY: Section for Count of results -->
            <!-- <div class="bg-white rounded-md p-2 my-4 flex items-center justify-between">
                <div class="px-2 py-1 text-xs bg-white rounded-md" role="alert"> -->
                    <!-- Display the complete message if a search term exists -->
                    <!-- <span v-if="hasSearchTerm">
                        {{ $t('your_search_term') }}
                        <span class="font-semibold">{{ stringSearchTerm }}</span>
                        {{ $t('yielded') + " " }}
                    </span>
                    <strong>{{ results.length > 0 ? numFound : 0 }}</strong> results
                </div>
            </div> -->

            <!-- MOBILE DEVICES ONLY: Area on top of the list of publications -->
            <!-- Section for Count of results -->
            <!-- <div class="bg-white rounded-md p-2 my-4 flex items-center justify-between"> -->
                <!-- Pagination before search results -->
                <!-- <PaginationTop class="pr-2 ml-auto" v-bind:data="pagination" @menu-click="onMenuClick"></PaginationTop>
            </div> -->

        <!-- </div> -->

        <!-- <div class="relative flex w-full h-[70vh] border-x border-gray-300 before:absolute before:z-20 before:top-0 before:left-0 before:h-full before:w-2 before:bg-gradient-to-r before:from-black 
        before:to-transparent before:opacity-20 after:absolute after:z-10 after:top-0 after:right-0 after:h-full after:w-2 after:bg-gradient-to-l after:from-black after:to-transparent after:opacity-20">
 -->

        <!-- Container for map + sidebar only -->
        <div class="relative flex w-full h-[80vh] border-y border-gray-300 
            before:absolute before:z-20 before:top-0 before:left-0 before:w-full before:h-2 before:bg-gradient-to-b before:from-black before:to-transparent before:opacity-20 
            after:absolute after:z-20 after:bottom-0 after:left-0 after:w-full after:h-2 after:bg-gradient-to-t after:from-black after:to-transparent after:opacity-30">

            <!-- LEFT SIDEBAR RESULTS OVER MAP -->
            <div class="flex flex-col top-0 left-0 z-10 bg-white shadow-lg transition-all duration-300 ease-in-out"
                :class="[
                    resultsPanelOpen ? 'md:w-[36vw] 2xl:w-[36vw]' : 'w-0 overflow-hidden',
                    // resultsPanelOpen ? 'shadow-[12px_0_8px_-4px_rgba(0,0,0,0.10)]' : ''
                ]">

                <!-- Results area on top of the list of publications for non-mobile devices -->
                <div class="flex justify-between items-center bg-gray-200">

                    <!-- <div class="hidden sm:flex w-[75vw] 2xl:w-[67vw] h-11"> -->
                    <div class="hidden sm:flex w-[75vw] 2xl:w-[67vw] h-14 items-end">
                        <!-- Section for Count of results  -->
                        <!-- <div class="w-full bg-tethys-blue1-light h-8 lg:h-11 flex mb-4 pl-3 items-center justify-between"></div> -->
                        <div class="w-full bg-tethys-1 h-8 lg:h-10 flex pl-3 items-center justify-between border-b-[1px] rounded-tr-lg shadow-[12px_-6px_8px_-4px_rgba(0,0,0,0.10)]">
                            <!-- Display message if a search term exists -->
                            <div v-if="hasSearchTerm" class="px-2 lg:py-1 text-xs bg-white rounded-lg" role="alert">
                                <span class="hidden 2xl:inline font-medium">{{ $t('your_search_term') }}</span>
                                <span class="font-semibold">{{ stringSearchTerm }}</span>{{ $t('yielded') }}
                                <strong>{{ results.length > 0 ? numFound : 0 }}</strong> {{ $t('results') }}:
                            </div>
                            <!-- Pagination before search results -->
                            <PaginationTop class="pr-2 ml-auto" v-bind:data="pagination" @menu-click="onMenuClick">
                            </PaginationTop>
                        </div>
                    </div>
                </div>

                <div class="flex-1 overflow-y-auto shadow-[12px_0_8px_-4px_rgba(0,0,0,0.10)]">
                    <vs-result-map :datasets="results" @document-hovered="onDocumentHovered"/>
                </div>

                <!-- Pages-found area below the list of publications for non-mobile devices -->
                <!-- <div class="flex items-center bg-tethys-blue1-light h-11"> -->
                <div class="flex items-start bg-gray-200 h-14">
                    <!-- Section for pagination element (RIGHT) -->
                    <!-- <div class="flex w-full h-full items-center justify-between"> -->
                    <div class="flex w-full items-center justify-between bg-tethys-1 h-10 border-t-[1px] rounded-br-lg shadow-[8px_6px_8px_-4px_rgba(0,0,0,0.20)]">
                        <!-- Pagination List after search results -->
                        <PaginationBase v-bind:data="pagination" @menu-click="onMenuClick"></PaginationBase>
                    </div>
                </div>

            </div>

            <!-- BACKGROUND MAP -->
            <HeroMap ref="heroMap" 
                @rectangle-drawn="onBboxRectangleDrawn"   
                @editing-enabled="editingEnabled = true"
                @editing-disabled="editingEnabled = false"
                class="flex-1 h-full z-0 transition-all duration-300" 
            />

            <!-- <HeroMap class="flex-1 h-full z-0 transition-all duration-300" /> -->

            <!-- TOGGLE ARROW BUTTON: FIXED TO LEFT + OFFSET -->
            <button
                class="absolute top-1/2 left-0 z-20 w-4 h-24 transform -translate-y-1/2 bg-white rounded-r-md hover:bg-gray-300 border-l-2 transition-all duration-300 ease-in-out flex items-center justify-center text-xs shadow-[10px_6px_8px_-4px_rgba(0,0,0,0.2)]"
                :class="{ 'md:ml-[36vw] 2xl:ml-[36vw]': resultsPanelOpen, 'ml-0': !resultsPanelOpen }"
                @click="resultsPanelOpen = !resultsPanelOpen"
                :title="resultsPanelOpen ? $t('hide_results') : $t('show_results')">
                <i :class="resultsPanelOpen ? 'fas fa-chevron-left' : 'fas fa-chevron-right'"></i>
            </button>

            <!-- GEOGRAPHIC INFO -->
            <!-- <div class="absolute top-5 left-5 z-20 h-8 px-2 py-1 text-sm bg-white rounded shadow-md transition-all duration-1000 ease-in-out flex items-center space-x-1"
                :class="{ 'ml-[700px]': resultsPanelOpen, 'ml-0': !resultsPanelOpen }"
            > -->
            <div v-if="!selectionBoxIsNull()" class="absolute top-5 left-5 z-20 h-8 px-2 py-1 text-sm bg-white rounded shadow-md transition-all duration-1000 ease-in-out flex items-center space-x-1"
                :class="{ 'ml-[700px]': resultsPanelOpen, 'ml-0': !resultsPanelOpen }"
            >
                <!-- Bounding Box Inputs -->
                <label class="text-xs font-medium px-2">{{ $t('bbox.geographic_bounding_box') }}:</label>
                <span class="space-x-1">
                    <input v-model="bboxXMin" @input="onBboxInput" :disabled ="!editingEnabled" placeholder="x_min" 
                        :class="[
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            editingEnabled ? 'text-black' : ' text-gray-400',
                            !selectionBoxIsNull() && !isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]"
                        title="x_min"
                    />
                    <input v-model="bboxYMin" @input="onBboxInput" :disabled ="!editingEnabled" placeholder="y_min" 
                        :class="[
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            editingEnabled ? 'text-black' : ' text-gray-400',
                            !selectionBoxIsNull() && !isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]"
                        title="y_min"
                    />
                    <input v-model="bboxXMax" @input="onBboxInput" :disabled ="!editingEnabled" placeholder="x_max" 
                        :class="[
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            editingEnabled ? 'text-black' : ' text-gray-400',
                            !selectionBoxIsNull() && !isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]"
                        title="x_max"
                    />
                    <input v-model="bboxYMax" @input="onBboxInput" :disabled ="!editingEnabled" placeholder="y_max" 
                        :class="[
                            'w-20 px-2 py-1 border rounded text-xs placeholder-gray-300',
                            editingEnabled ? 'text-black' : ' text-gray-400',
                            !selectionBoxIsNull() && !isValidBboxInput() ? 'border-red-500' : ' border-gray-300'
                        ]"
                        title="y_max"
                    />
                </span>

                <!-- Icon Buttons -->

                <button
                    @click="enableRectangleEditing"
                    :disabled="selectionBoxIsNull()"
                    :class="[
                        'ml-2 px-2 py-1 text-white rounded transition text-xs',
                        !selectionBoxIsNull() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]"
                    :title="$t('bbox.edit')"
                >
                    <i class="fa-regular fa-pen-to-square"></i>
                </button>

                <button
                    @click="applyBoundingBox"
                    :disabled="!canApplyBoundingBox()"
                    :class="[
                        'px-2 py-1 text-white rounded transition text-xs',
                        canApplyBoundingBox() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]"
                    :title="$t('bbox.apply')"
                >
                    <i class="fas fa-check"></i>
                </button>

                <button 
                    @click="clearBoundingBox"
                    :disabled="selectionBoxIsNull()"
                    :class="[
                        'px-2 py-1 text-white rounded transition text-xs',
                        !selectionBoxIsNull() ? 'bg-tethys-blue1-dark hover:bg-black' : 'bg-gray-200 cursor-default'
                    ]"
                    :title="$t('bbox.remove')"
                >
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <!-- class="absolute top-5 right-5 z-20 h-8 px-3 py-1 text-xs bg-white rounded shadow-md hover:bg-gray-200 transition flex items-center text-black no-underline font-normal"> -->
            <router-link to="/search"
                class="absolute top-5 right-5 z-20 h-8 px-3 py-1 text-xs bg-white rounded shadow-md hover:bg-gray-200 transition flex items-center text-black no-underline font-normal">
                <span class="pb-0.5">{{ $t('mapButtons.close_map') }}</span>
                <i class="fas fa-times pl-2"></i>
            </router-link>

        </div>

        <!-- MOBILE DEVICES ONLY: Results area below the list of publications -->
        <div class="flex sm:hidden w-[85vw]">
            <!-- Section for results information -->
            <div class="bg-white h-11 rounded-md my-3 flex w-full items-center justify-between">
                <!-- Button to go up to the top -->
                <a class="inline-block px-2 py-1 ml-2 mr-1 border border-gray-300 shadow-sm hover:bg-gray-300 transition-colors text-xs font-normal text-primary-tethys rounded cursor-pointer"
                    :title="$t('go_to_search_bar')">
                    <i class="fas fa-arrow-up" @click="scrollToTop()"></i>
                </a>
                <!-- Pagination after search results (Despite the component name, in mobile devices it comes below the results) -->
                <PaginationTop class="pr-2 ml-auto" v-bind:data="pagination" @menu-click="onMenuClick"></PaginationTop>
            </div>
        </div>


    </div>
</template>

<script lang="ts">
import PaginationBase from "@/components/PaginationBase.vue";
import MapViewComponent from "./map-view-component";
export default MapViewComponent;
// Import Tailwind CSS
import "@/index.css";
</script>


<style scoped lang="scss">
// .search-banner {
//     // background-image: url('/src/assets/site/img/main-search-banner.jpg');
//     background-image: url('/src/assets/site/img/hero_image_static.png');
// }</style>